import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MovimientosComponent } from 'src/app/modales/movimientos/movimientos.component';


declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [
    './home.component.css',
    '../login/font-awesome/css/font-awesome.min.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'

  ],
  providers: [UserService]
})
export class HomeComponent implements OnInit {
  clock;
  identity: any = {};
  aportes;
  aportesasociado;
  mvtoaportes;
  mvtoaportesasociado;
  paginaactual: Number = 1;
  token;
  user: User;
  date;
  estado;
  aportesuser;
  public actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public porcentaje = environment.entidad[this.actual].porcentaje;
  public calculoaporte = environment.entidad[this.actual].calculoaporte;
  public cuotaaporte = environment.entidad[this.actual].cuotaaporte;
  public aportesConfig;
  public idAnalitycs = environment.entidad[this.actual].idAnalitycs;
  public mobile
  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
  }


  ngOnInit() {
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.aportesConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    //this.aportesuser = ((this.identity.SALARIO * this.identity.PAPORTE) / 100);
    if (this.actual != 'fsv') {
      this.consultAportes();
    }
    this.date = new Date().toLocaleDateString();
    if (this.actual == 'clientes') {
      this.router.navigate(['/decsisCloud'])
    }

    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  decodeBuffer(arraybuffer?) {
    if (arraybuffer != null) {
      return String.fromCharCode.apply(null, new Uint16Array(arraybuffer));
    }
  }

  consultAportes() {
    this.spinner.show()
    const date = new Date();
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day
    };


    this._userService.httpPost('aportes', data).subscribe(
      response => {
        this.spinner.hide()
        if (response.status != 'error') {
          this.aportes = response.details;
        } else {
          console.log(response.details)
        }
      },
      error => {
        console.log(error as any);
        this._userService.httpAjax('POST', 'aportes', data).then(response => {
          this.spinner.hide()
          if (response.status != 'error') {
            this.aportes = response.details;
          } else {
            console.log(response.details)
          }
        }).catch(err => {
          this.spinner.hide()
        })
      }
    );
  }

  consultarMovientos(codmoviento) {
    this.spinner.show()
    this.mvtoaportes = [];
    this.paginaactual = 1;
    const data = {
      codasociado: this.identity.CODASOCIADO,
      codaporte: codmoviento
    };
    this._userService.httpPost('mvtoaportes', data).subscribe(response => {
      this.mvtoaportes = response;
      if (this.mobile) {
        this.scrollTOElement('#target', 300, 500);
      } else {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.width = '100%';
        const modalRef = this.dialog.open(MovimientosComponent, {
          autoFocus: false,
          maxHeight: '80vh',
          width: '100%', //you can adjust the value as per your view
          data: { datos: this.mvtoaportes, modulo: 'mvtoaportes', op: 1 }
        });

        modalRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
        });
      }
      this.spinner.hide()
    },
      error => {
        console.log(error as any);
        this._userService.httpAjax('POST', 'mvtoaportes', data).then(response => {
          this.mvtoaportes = response;
          this.scrollTOElement('#target', 300, 500);
          this.spinner.hide()
        })
      }
    );
  }


  scrollTOElement = (element, offsetParam?, speedParam?) => {
    const toElement = $(element);
    const focusElement = $(element);
    const offset = offsetParam * 1 || 200;
    const speed = speedParam * 1 || 500;
    $('html, body').animate({
      scrollTop: toElement.offset().top + offset
    }, speed);
    if (focusElement) {
      $(focusElement).focus();
    }
  }
}
